import React from 'react';
import { FaChrome, FaFirefox, FaSafari, FaEdge, FaGlobe } from 'react-icons/fa';

const BrowserAnalytics = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-400">
        <p>No browser data available</p>
      </div>
    );
  }

  const totalClicks = data.reduce((sum, item) => sum + item.count, 0);

  const getBrowserIcon = (browser) => {
    switch (browser) {
      case 'chrome':
        return <FaChrome className="w-5 h-5 text-blue-500" />;
      case 'firefox':
        return <FaFirefox className="w-5 h-5 text-orange-500" />;
      case 'safari':
        return <FaSafari className="w-5 h-5 text-blue-400" />;
      case 'edge':
        return <FaEdge className="w-5 h-5 text-blue-600" />;
      default:
        return <FaGlobe className="w-5 h-5 text-gray-500" />;
    }
  };

  const getBrowserLabel = (browser) => {
    switch (browser) {
      case 'chrome':
        return 'Chrome';
      case 'firefox':
        return 'Firefox';
      case 'safari':
        return 'Safari';
      case 'edge':
        return 'Edge';
      case 'other':
        return 'Other';
      default:
        return browser;
    }
  };

  const getBrowserColor = (browser) => {
    switch (browser) {
      case 'chrome':
        return 'bg-blue-500';
      case 'firefox':
        return 'bg-orange-500';
      case 'safari':
        return 'bg-blue-400';
      case 'edge':
        return 'bg-blue-600';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="space-y-4 flex-grow">
        {data.map((item, index) => {
          const percentage = totalClicks > 0 ? Math.round((item.count / totalClicks) * 100) : 0;
          return (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {getBrowserIcon(item.browser)}
                <div className="text-left">
                  <div className="text-white font-medium">{getBrowserLabel(item.browser)} <span className="text-sm text-gray-400">({item.count} clicks)</span></div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <div className="text-white font-semibold">{percentage}%</div>
                </div>
                
                <div className="w-24 bg-gray-700 rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full ${getBrowserColor(item.browser)} transition-all duration-300`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{totalClicks}</div>
            <div className="text-sm text-gray-400">Total Clicks</div>
          </div>
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{data.length}</div>
            <div className="text-sm text-gray-400">Browser Types</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserAnalytics;
